<script>
import * as R from 'ramda'
import { MessageBox, Toast } from 'mint-ui'
import { mapGetters, mapState } from 'vuex'

import CONSTANT from '../../../constant/preorder'
import validator from '../../../util/validator/seat'
import { getSectionMap } from '@util/schedule'

import '../../../../stylesheet/iconfont/seatlock'
import '../../../../stylesheet/iconfont/iconfont'

const BROKEN_SEAT = 'BROKEN_SEAT'
const OCCUPIED_SEAT = 'OCCUPIED_SEAT'
const SELECTABLE_SEAT = 'SELECTABLE_SEAT'
const SELECTED_SEAT = 'SELECTED_SEAT'

const COUPLE_SEAT = 'COUPLE_SEAT'
const SINGLE_SEAT = 'SINGLE_SEAT'

const COUPLE_SEAT_IS_LEFT = 1
const COUPLE_SEAT_IS_RIGHT = 2

const SEAT_DEFAULT_WIDTH = 25
const SEAT_DEFAULT_HEIGHT = 25
import singleBrokenSeatsImg from '../../../../image/schedule/single-lock.png'
import doubleBrokenSeatsImg from '../../../../image/schedule/double-lock.png'
import op from 'object-path'
export default {
  props: {
    selected: Boolean,
    c: Function,
    authType: Number,
    id: [String, Number],
  },
  methods: {
    checkSeatValid(nexts) {
      const seletedSeats = this.getPreorderSelectedSeats
      const all = this.seats
      const schedule = this.schedule
      // 这里开始校验规则
      const strong = validator.strong(nexts, schedule)
      const weak = validator.weak()(all, nexts)
      const maxLine = validator.maxLine()(all, nexts)
      const ruleCheckType = op(this.schedule).get('lockSeatRules.ruleCheckType') || 1
      //处理一下list
      const rules = op(this.schedule).get('lockSeatRules.rules') || []
      let arr = []
      rules.map(v => {
        arr.push(v.ruleType)
      })
      if (ruleCheckType === 1) {
        if (strong && arr.find(v => v == 2)) {
          Toast({
            message: strong,
            position: 'bottom',
            duration: 3000,
          })
          return false
        }
        if (weak && arr.find(v => v == 1)) {
          Toast({
            message: weak,
            position: 'bottom',
            duration: 3000,
          })
          this.$store.commit(CONSTANT.PREORDER_IS_SEATS_SELECTION_VALID, false)
          return true
        }
        if (maxLine && arr.find(v => v == 3)) {
          Toast({
            message: maxLine,
            position: 'bottom',
            duration: 3000,
          })
          this.$store.commit(CONSTANT.PREORDER_IS_SEATS_SELECTION_VALID, false)
          return true
        }
      }

      this.$store.commit(CONSTANT.PREORDER_IS_SEATS_SELECTION_VALID, true)
      return true
    },
    isSeletected(seat) {
      const selectedSeats = this.getPreorderSelectedSeats
      return R.contains(seat, selectedSeats)
    },
    select(seat, ev) {
      let list = []
      let next = [seat]
      const all = this.seats
      const selectedSeats = this.getPreorderSelectedSeats || []
      // 拒绝选择无效的座位
      if (seat.isOccupied || seat.isBroken) {
        return
      }
      // 处理情侣座情况
      if (seat.coupleType === COUPLE_SEAT_IS_LEFT) {
        const findRight = R.find(s => {
          return +s.rowNum === +seat.rowNum && +s.columnNum === +seat.columnNum + 1 && s.coupleType === COUPLE_SEAT_IS_RIGHT
        })(all)
        next = [seat, findRight]
      }
      const findPreSeats = R.filter(s => {
        return R.find(ns => {
          return ns.columnNum === s.columnNum && ns.rowNum === s.rowNum
        })(next)
      })(selectedSeats)
      // 已选位置则反选
      if (!R.isEmpty(findPreSeats)) {
        // warning!!!!!!!!!!!!!!!!!!!!!
        // selectedSeats.splice(findPreIndex, 1)
        list = R.reject(s => {
          return R.find(ns => {
            return ns.columnNum === s.columnNum && ns.rowNum === s.rowNum
          })(findPreSeats)
        })(selectedSeats)
      } else {
        list = R.concat(selectedSeats, next)
      }
      this.$emit('handleZoomSeat', seat, ev)
      if (!this.checkSeatValid(list)) {
        return
      }
      // console.log('comit to set seats ', list.map((l) => {return l.rowId + ':' + l.columnId}))
      this.$store.commit(CONSTANT.PREORDER_SET_SEATS, list)
      // if (this.authType == 3) {
      //   this.$store.commit('clearSelectList')
      // }
    },
    type(seat) {
      if (seat.coupleType === COUPLE_SEAT_IS_LEFT || seat.coupleType === COUPLE_SEAT_IS_RIGHT) {
        return COUPLE_SEAT
      }
      return SINGLE_SEAT
    },
    status(seat) {
      if (seat.isBroken) {
        return BROKEN_SEAT
      }
      if (seat.isOccupied) {
        return OCCUPIED_SEAT
      }
      // seleted seats
      if (R.contains(seat, this.getPreorderSelectedSeats)) {
        return SELECTED_SEAT
      }
      return SELECTABLE_SEAT
    },
    getSeatPosition(s) {
      const column = s.columnNum
      const row = s.rowNum
      if (s.coupleType === COUPLE_SEAT_IS_RIGHT) {
        return {
          display: 'none',
        }
      }
      return {
        left: (column - 1) * SEAT_DEFAULT_WIDTH + 'px',
        top: (row - 1) * SEAT_DEFAULT_HEIGHT + 'px',
      }
    },
    getSeatIndex(seat) {
      return op.get(this.sectionMap[seat.sectionId], 'index') || 1
    },
  },
  computed: {
    ...mapGetters(['getPreorderSelectedSeats', 'getScheduleDetailById']),
    ...mapState({
      seats: state => R.path(['schedule', 'seatingChart', 'seats'], state) || [],
      seatingChart: state => state.schedule.seatingChart,
    }),
    schedule() {
      return this.getScheduleDetailById(this.id)
    },
    sectionPrices() {
      return op.get(this.schedule, 'sectionPrices') || []
    },
    sectionMap() {
      return getSectionMap(this.seatingChart, this.sectionPrices)
    },
    // 是否支持分区定价
    isSupportSectionPrice() {
      return this.sectionPrices.length > 1
    },
  },
}
</script>
<template>
  <div class="seats">
    <div class="seat" v-for="(seat, i) in seats" :style="getSeatPosition(seat)" @click="select(seat, $event)">
      <!-- 情侣座 -->
      <div class="couple" v-if="type(seat) === 'COUPLE_SEAT' && seat.coupleType === 1">
        <!-- 情侣座 & 座位坏了 -->
        <div class="occupied" v-if="status(seat) === 'BROKEN_SEAT'">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-icon_lovers_lock" />
          </svg>
        </div>
        <!-- 情侣座 & 被占用 -->
        <div class="occupied" v-else-if="status(seat) === 'OCCUPIED_SEAT'">
          <svg class="icon icon-couple-occupied" aria-hidden="true">
            <use xlink:href="#icon-zuowei-qinglv-yishou" />
          </svg>
        </div>
        <!-- 情侣座 & 已被选 -->
        <div class="selected" v-else-if="status(seat) === 'SELECTED_SEAT'">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-1-13" />
          </svg>
        </div>
        <!-- 情侣座 & 未被选 & 分区定价 -->
        <div class="normal" v-else-if="isSupportSectionPrice">
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="`#icon-zuowei-${getSeatIndex(seat)}`" />
          </svg>
        </div>
        <!-- 情侣座 & 未被选-->
        <div class="normal" v-else>
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-1-121" />
          </svg>
        </div>
      </div>
      <!-- 单人座 -->
      <div class="single" v-else-if="type(seat) === 'SINGLE_SEAT'">
        <!-- 单人座 & 座位坏了 -->
        <div class="occupied" v-if="status(seat) === 'BROKEN_SEAT'">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-icon_lock1" />
          </svg>
        </div>
        <!-- 单人座 & 被占用 -->
        <div class="occupied" v-else-if="status(seat) === 'OCCUPIED_SEAT'">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-zuowei-danren-yishou" />
          </svg>
        </div>
        <!-- 单人座 & 被选 -->
        <div class="selected" v-else-if="status(seat) === 'SELECTED_SEAT'">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-1-141" />
          </svg>
        </div>
        <!-- 单人座 & 未被选 & 分区定价 -->
        <div class="normal" v-else-if="isSupportSectionPrice">
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="`#icon-1-${getSeatIndex(seat)}`" />
          </svg>
        </div>
        <!-- 单人座 & 未被选 -->
        <div class="normal" v-else>
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-1-11" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.seats {
  position: relative;
  .seat {
    -webkit-transition: all 0.4s ease;
    transition: all 0.4s ease;
    .icon {
      width: 1em;
      height: 1em;
      position: absolute;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
    }
    position: absolute;
    display: inline-block;
    margin: 2.5px;
    .single {
      width: 24px;
      height: 24px;
      overflow: hidden;
      position: relative;
      .icon {
        font-size: 20px;
      }
    }
    .couple {
      width: 47px;
      height: 20px;
      overflow: hidden;
      position: relative;
      .icon {
        font-size: 45px;
        top: -0.26em;
      }
    }
    .normal {
      height: 100%;
    }
    .occupied {
      height: 100%;
    }
    .seat-broken {
      width: 100%;
      height: 100%;
    }
    .selected {
      position: relative;
      height: 100%;
      width: 100%;
      color: #fff;
      .pos {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        font-size: 6px;
        text-align: center;
        line-height: 7px;
        padding-top: 4px;
        right: 0;
        z-index: 2;
        span {
          display: inline-block;
          width: 100%;
        }
        .row {
        }
      }
    }
  }
}
</style>
